import { render } from "./Mm.vue?vue&type=template&id=e63bd8b0"
import script from "./Mm.vue?vue&type=script&lang=js"
export * from "./Mm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__